import React from "react";
import PublicNavbar from "../../components/public/PublicNavbar";

const Privacy = () => {
    return (
        <div className="min-h-screen bg-[#FFFFFF] text-[#263746] font-sans">
            <PublicNavbar />

            <div className="bg-[#F7F5EF] border-b border-[#E5E7EB] py-12 px-6 text-center">
                <div className="max-w-4xl mx-auto">
                    <span className="text-[#E3B629] text-xs font-black tracking-[0.25em] uppercase block mb-1">
                        Data Protection & Confidentiality
                    </span>
                    <h1 className="text-3xl sm:text-4xl font-extrabold text-[#263746]">
                        Privacy Policy
                    </h1>
                    <p className="text-[#687482] text-xs sm:text-sm mt-2">
                        LUMIGO PROJECTION SOLUTIONS • Fourlifters Private Limited • Client Information Handling Practice
                    </p>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-6 py-12 space-y-8 text-[#687482] text-xs sm:text-sm leading-relaxed">
                <div className="p-4 rounded-xl bg-[#F7F5EF] border border-[#E5E7EB] text-[#263746] text-xs font-medium">
                    <strong>Privacy Commitment:</strong> LUMIGO (Fourlifters Private Limited) respects commercial confidentiality. We do not sell, rent, or trade your personal or enterprise information to advertising brokers.
                </div>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        1. Information Collected
                    </h2>
                    <p>
                        When you interact with our catalogue or submit a project quotation request, we collect only the necessary details required to evaluate your projection requirements and communicate with you:
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-[#687482]">
                        <li>Contact Details: Name, telephone number, WhatsApp number, and corporate email.</li>
                        <li>Company Details: Organization name, city, and shipping / project location.</li>
                        <li>Technical Requirements: Throw distance, artwork attachments, model preferences, and optical configuration.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        2. Purpose of Data Processing
                    </h2>
                    <p>
                        Your information is processed strictly for:
                    </p>
                    <ul className="list-disc list-inside space-y-1 text-[#687482]">
                        <li>Evaluating technical feasibility and optical calculations.</li>
                        <li>Issuing formal commercial quotations and lead time schedules.</li>
                        <li>Communicating status updates via email and WhatsApp.</li>
                        <li>Facilitating dispatch logistics and warranty service records.</li>
                    </ul>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        3. No Financial Data Storage
                    </h2>
                    <p>
                        Because LUMIGO does not process credit cards, debit cards, or net banking directly through the web platform, we never capture, handle, or store sensitive financial instruments, CVVs, or cardholder numbers on our web servers.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        4. Data Security & Retention
                    </h2>
                    <p>
                        Enquiries and customer account records are stored securely in isolated database environments with role-based access control. Information is retained for the duration necessary to support ongoing warranty and historical project reference.
                    </p>
                </section>

                <section className="space-y-3">
                    <h2 className="text-base font-bold text-[#263746] uppercase tracking-wider">
                        5. Contacting Our Data Desk
                    </h2>
                    <p>
                        For questions regarding data privacy or to request update/deletion of your contact details, please reach out directly:
                    </p>
                    <p className="font-semibold text-xs text-[#263746]">
                        Fourlifters Private Limited (Brand: LUMIGO)<br />
                        E-21/22, Kaygee Engineering Premises, T Block, MIDC Bhosari, Pune, Maharashtra - 411026<br />
                        Email: fourlifters@gmail.com / sales@fourlifters.in | WhatsApp: +91 8087680893 | Website: www.fourlifters.in
                    </p>
                </section>
            </div>
        </div>
    );
};

export default Privacy;
